import { useContext } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useFacetData } from '~/contexts/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import LabelWithCount from './LabelWithCount';
import { CommonWrapper } from './styles';
import useExpand from './useExpand';

export default function Cylinders() {
  const [show, setShow] = useExpand(false);
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const facetData = useFacetData();

  return (
    <FilterDrawer
      dataQa="facet-cylinderCounts"
      facetContent={facetData.cylinderCounts?.buckets ?? []}
      facetName="Cylinders"
      scrollIntoView
      show={show}
      onToggle={() => {
        setShow(!show);
      }}
    >
      <CommonWrapper>
        {facetData.cylinderCounts?.buckets?.map(
          ({ count, displayName, key }) => (
            <Checkbox
              checked={appliedFilters.cylinderCounts?.includes(key)}
              facet="cylinderCounts"
              filter={key}
              id={`cylinderCounts-${key}`}
              key={key}
              label={<LabelWithCount count={count} displayName={displayName} />}
              onChange={() =>
                updateListFilter({
                  filterKey: 'cylinderCounts',
                  value: key
                })
              }
            />
          )
        )}
      </CommonWrapper>
    </FilterDrawer>
  );
}
